/**
 * Paso del código de verificación (segundo factor por correo), separado de la pantalla
 * para poder probarlo sin navegador. Ver apps/api/src/lib/otp.ts.
 */
import { rutaDeRegresoValida } from './sesionCerrada.js';

export const RUTA_VERIFICAR_ACCESO = '/verificar-acceso';

export interface DatosDeVerificacion {
  desafio: string;
  destino: string;
  volver: string;
}

/** URL de la pantalla de verificación. */
export function rutaDeVerificacion(d: { desafio: string; destino?: string | null; volver?: string | null }): string {
  const q = new URLSearchParams({ desafio: d.desafio });
  if (d.destino) q.set('destino', d.destino);
  q.set('volver', rutaDeRegresoValida(d.volver ?? '/'));
  return `${RUTA_VERIFICAR_ACCESO}?${q.toString()}`;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Lee los parámetros de la pantalla. `null` si falta el desafío o no tiene forma válida. */
export function leerVerificacion(params: URLSearchParams): DatosDeVerificacion | null {
  const desafio = params.get('desafio') ?? '';
  if (!UUID.test(desafio)) return null;
  return {
    desafio,
    destino: (params.get('destino') ?? '').slice(0, 120),
    volver: rutaDeRegresoValida(params.get('volver')),
  };
}

/** Normaliza lo que escribió la persona: solo dígitos. Válido si quedan exactamente 6. */
export function normalizarCodigo(texto: string): string {
  return texto.replace(/\D+/g, '').slice(0, 6);
}

export function codigoCompleto(texto: string): boolean {
  return /^\d{6}$/.test(normalizarCodigo(texto));
}
